export default __webpack_public_path__ + "static/media/web_dev_img.88ed2186.svg";